
export  class Row {
    id:number;
    position:number;
    created_by:number;
    updated_by:number;
    created_at:Date;
    updated_at:Date;
    project_id:number;
}